module.exports = __webpack_public_path__ + "static/media/restaurant-2.f57d0c6e.jpg";